import { ITimeSource } from "app/common/time_source";
import * as $ from "jquery";
import * as moment from "moment";
import { ISignal, SignalDispatcher } from "strongly-typed-events";

const refreshDomSelector = "#navbar-refresh i";
const refreshIdleClass = "fa-hourglass";
const refreshWorkingClass = "fa-refresh";

const updateLoopDuration = moment.duration(3, "s");

export interface IActivityMonitor {
    readonly isActive: boolean;
    readonly activityStarted: ISignal;
    readonly activityStopped: ISignal;
}

export class ActivityMonitor implements IActivityMonitor {

    public readonly activityThreshold = moment.duration(30, "s");
    public readonly longActivityThreshold = moment.duration(15, "m");

    private readonly timeSource: ITimeSource;
    private active: boolean;
    private pausedForDebugging: boolean;
    private lastActive: moment.Moment;
    private readonly activityStartedDispatcher: SignalDispatcher = new SignalDispatcher();
    private readonly activityStoppedDispatcher: SignalDispatcher = new SignalDispatcher();

    public constructor(timeSource: ITimeSource) {
        this.timeSource = timeSource;

        this.refreshActivity();

        $(document).on("mousemove", () => this.refreshActivity());
        $(document).on("mousedown", () => this.refreshActivity());
        $(document).on("touchstart", () => this.refreshActivity());
        $(document).on("keydown", () => this.refreshActivity());

        setInterval(() => this.update(), updateLoopDuration.asMilliseconds());
    }

    public get isActive(): boolean {
        this.update();
        return this.active;
    }

    public get isPausedForDebugging(): boolean {
        return this.pausedForDebugging;
    }

    public get activityStarted(): ISignal {
        return this.activityStartedDispatcher.asEvent();
    }

    public get activityStopped(): ISignal {
        return this.activityStoppedDispatcher.asEvent();
    }

    public wasLastActivityWithin(duration: moment.Duration): boolean {
        return this.timeSource.now().subtract(duration) <= this.lastActive;
    }

    public pauseForDebugging(): void {
        this.pausedForDebugging = true;
        this.update();
    }

    public resumeForDebugging(): void {
        this.pausedForDebugging = false;
        this.update();
    }

    private refreshActivity(): void {
        this.lastActive = this.timeSource.now();
        if (!this.active) {
            this.update();
        }
    }

    private update(): void {
        const active = this.wasLastActivityWithin(this.activityThreshold)
            && isTabActive()
            && !this.isPausedForDebugging;

        if (active === this.active) {
            return;
        }

        if (active) {
            this.active = true;

            $(refreshDomSelector).addClass(refreshWorkingClass);
            $(refreshDomSelector).removeClass(refreshIdleClass);

            this.activityStartedDispatcher.dispatch();
        } else {
            this.active = false;

            $(refreshDomSelector).addClass(refreshIdleClass);
            $(refreshDomSelector).removeClass(refreshWorkingClass);

            this.activityStoppedDispatcher.dispatch();
        }
    }
}

function isTabActive(): boolean {
    return !document.hidden;
}
